<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="sales-general-sales-tab" :class="{ 'form-disabled': disabled }">
    <div class="row">
      <!-- General Plant Data (FORM02: sales_general_sales.cat_emcr_sales_general) -- baris = baris tabel Plant (`rows_from`). -->
      <div v-if="isTableVisible(SALES_TAB, SALES_GENERAL_FIELD)" :class="showSales ? 'col-md-6' : 'col-12'">
        <div class="card h-100">
          <div class="card-header py-3 pb-2" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">General Plant Data</h6>
            <small class="text-muted">Rows follow the Plant table in the Plant &amp; Storage Location tab.</small>
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[SALES_GENERAL_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="420px">
              <template v-for="col in SALES_GENERAL_COLUMNS" :key="col.column">
                <Column v-if="isColumnVisibleFn(col.column, SALES_GENERAL_FIELD, SALES_TAB)" header-class="bg-light text-center" :style="columnWidth(col.width)">
                  <template #header>
                    {{ col.label }} <span v-if="isColumnMandatoryFn(col.column, SALES_GENERAL_FIELD, SALES_TAB)" class="exclamation-mark-error-tab">*</span>
                  </template>
                  <template #body="{ data }">
                    <SelectPrime show-clear v-model="data[col.column]" size="small" fluid :filter="!col.readonly"
                      :options="dialog.options[columnOptionsKey(SALES_TAB, SALES_GENERAL_FIELD, col.column, data)]"
                      option-label="label" option-value="value" :placeholder="`Select ${col.label}`"
                      :loading="dialog.loading[columnOptionsKey(SALES_TAB, SALES_GENERAL_FIELD, col.column, data)]"
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || col.readonly || isColumnLocked(SALES_TAB, SALES_GENERAL_FIELD, col.column, data) || !isColumnEnabledFn(col.column, SALES_GENERAL_FIELD, SALES_TAB)"
                      @show="loadColumnOptions(SALES_TAB, SALES_GENERAL_FIELD, col.column, data)"
                      @change="onColumnChange(SALES_TAB, SALES_GENERAL_FIELD, col.column, data)"
                    >
                      <template #value="{ value, placeholder }">
                        <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(SALES_TAB, SALES_GENERAL_FIELD, col.column, data)], value) }}</span>
                        <span v-else>{{ placeholder }}</span>
                      </template>
                    </SelectPrime>
                  </template>
                </Column>
              </template>
              <template #empty>
                <div class="text-muted text-center small py-3">No plant yet. Add a plant in the Plant &amp; Storage Location tab.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>

      <!-- Sales (FORM02: sales_general_sales.cat_emcr_sales) -->
      <div v-if="showSales" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Sales <span v-if="isTableMandatory(SALES_TAB, SALES_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(SALES_TAB, SALES_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(SALES_TAB, SALES_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[SALES_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="420px">
              <template v-for="col in SALES_COLUMNS" :key="col.column">
                <Column v-if="isColumnVisibleFn(col.column, SALES_FIELD, SALES_TAB)" header-class="bg-light text-center" :style="columnWidth(col.width)">
                  <template #header>
                    {{ col.label }} <span v-if="isColumnMandatoryFn(col.column, SALES_FIELD, SALES_TAB)" class="exclamation-mark-error-tab">*</span>
                  </template>
                  <template #body="{ data, index }">
                    <!-- Kolom level item (Tax): BE menyimpan satu record per item dari baris PERTAMA, jadi cuma baris pertama
                         yang bisa diisi; baris lain menampilkan nilai baris pertama (read-only). -->
                    <div v-if="col.type === 'select'" class="d-flex align-items-center gap-1">
                    <SelectPrime show-clear size="small" fluid class="flex-grow-1" style="min-width: 0" :filter="col.filter"
                      :model-value="valueRow(col, data, index)[col.column]"
                      :options="dialog.options[columnOptionsKey(SALES_TAB, SALES_FIELD, col.column, valueRow(col, data, index))]"
                      option-label="label" option-value="value" :placeholder="`Select ${col.label}`"
                      :loading="dialog.loading[columnOptionsKey(SALES_TAB, SALES_FIELD, col.column, data)]"
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || isCellLocked(col.column, data) || (col.itemLevel && index > 0) || !isColumnEnabledFn(col.column, SALES_FIELD, SALES_TAB)"
                      @update:model-value="data[col.column] = $event"
                      @show="loadColumnOptions(SALES_TAB, SALES_FIELD, col.column, data)"
                      @change="onColumnChange(SALES_TAB, SALES_FIELD, col.column, data)"
                    >
                      <template #value="{ value, placeholder }">
                        <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(SALES_TAB, SALES_FIELD, col.column, valueRow(col, data, index))], value) }}</span>
                        <span v-else>{{ placeholder }}</span>
                      </template>
                    </SelectPrime>
                    <!-- Tombol Alternative UoM (config `alt_uom` di kolom, mis. Sales Unit). -->
                    <ButtonPrime v-if="altUomOf(SALES_TAB, SALES_FIELD, col.column)" icon="pi pi-link" size="small" outlined
                      v-tooltip.top="hasAltUomError(altUomOf(SALES_TAB, SALES_FIELD, col.column)) ? 'Alternative UoM: please complete the required fields' : 'Alternative UoM'"
                      :severity="hasAltUomError(altUomOf(SALES_TAB, SALES_FIELD, col.column)) ? 'danger' : undefined"
                      class="flex-shrink-0" :disabled="!canOpenAltUom(altUomOf(SALES_TAB, SALES_FIELD, col.column), data[col.column])"
                      @click="openAltUomPopup(altUomOf(SALES_TAB, SALES_FIELD, col.column), data[col.column])" />
                    </div>
                    <div v-else-if="col.type === 'checkbox'" class="text-center">
                      <Checkbox v-model="data[col.column]" :binary="true" true-value="X" :false-value="null"
                        :disabled="disabled || isCellLocked(col.column, data) || !isColumnEnabledFn(col.column, SALES_FIELD, SALES_TAB)"
                      />
                    </div>
                  </template>
                </Column>
              </template>
              <Column v-if="canRemoveRow(SALES_TAB, SALES_FIELD)" header-class="bg-light text-center" style="width: 56px">
                <template #header>Action</template>
                <template #body="{ data, index }">
                  <!-- Satu grup per Distribution Channel (10, 20): hapus di baris pertama = seluruh grup ikut terhapus. -->
                  <ButtonPrime v-if="!isSplitFollower(data)" icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled" @click="removeRow(SALES_FIELD, index)" />
                </template>
              </Column>
              <template #empty>
                <div class="text-muted text-center small py-3">No sales data yet.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>

    <AlternativeUomPopup v-model:visible="dialog.altUom.visible" :rows="mcrItem.cat_emcr_alternative_uoms || []"
      :open-by="dialog.altUom.openBy" :readonly="disabled" />
  </div>
</template>

<script>
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";
import AlternativeUomPopup from "./New_AlternativeUomPopup.vue";

// Key tab & field repeatable di FORM02_BASE.json
const SALES_TAB = "sales_general_sales";
const SALES_GENERAL_FIELD = "cat_emcr_sales_general";
const SALES_FIELD = "cat_emcr_sales";

// Layout kolom (urutan, label, jenis input) -- hardcode di Vue sesuai prinsip "layout hardcode, behavior dynamic".
// Tampil/wajib/enabled/opsi tiap kolom dari config FORM02. Checkbox disimpan "X" / null.
// Plant General Plant Data `readonly`: penanda baris (diisi dari tabel Plant, `rows_from`), sama seperti tab MRP.
const SALES_GENERAL_COLUMNS = [
  { column: "plant", label: "Plant", type: "select", width: 160, readonly: true },
  { column: "profit_center", label: "Profit Center", type: "select", width: 220 },
  { column: "loading_group", label: "Loading Group", type: "select", width: 200 }
];

// `itemLevel`: data level item (cat_emcr_item_tax), disimpan BE dari baris Sales pertama saja.
const SALES_COLUMNS = [
  { column: "delivering_plant", label: "Delivering Plant", type: "select", width: 200, filter: true },
  { column: "material_price", label: "Material Price", type: "select", width: 200, filter: true },
  { column: "distr_channel", label: "Distribution Channel", type: "select", width: 200, filter: true },
  { column: "sales_unit", label: "Sales Unit", type: "select", width: 180, filter: true },
  { column: "sales_organization", label: "Sales Organization", type: "select", width: 200, filter: true },
  { column: "item_cat_group", label: "Item Category Group", type: "select", width: 200, filter: true },
  { column: "acc_ass_group", label: "Account Assignment Group", type: "select", width: 220, filter: true },
  { column: "cash_discount", label: "Cash Discount", type: "checkbox", width: 120 },
  { column: "material_statistic_code", label: "Material Statistic Code", type: "select", width: 220, filter: true },
  { column: "commission_group", label: "Commission Group", type: "checkbox", width: 140 },
  { column: "departure_country", label: "Departure Country", type: "select", width: 180, itemLevel: true },
  { column: "tax_category", label: "Tax Category", type: "select", width: 200, filter: true, itemLevel: true },
  { column: "tax_classification", label: "Tax Classification", type: "select", width: 200, filter: true, itemLevel: true }
];

// Props, setup engine, dialog, bind ke mcrItem, addRow/removeRow/opsi kolom: kerangka bersama New_CataloguerTab.js.
export default {
  name: "SalesGeneralSales",
  components: { AlternativeUomPopup },
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props);
  },
  data() {
    return {
      SALES_TAB,
      SALES_GENERAL_FIELD,
      SALES_FIELD,
      SALES_GENERAL_COLUMNS,
      SALES_COLUMNS,
      dialog: createTabDialog(this.mcrItem)
    };
  },
  watch: {
    // Tabel Sales baru tampil / baris otomatis baru berlaku (mis. Material Type diganti ke ZFGD, `split_rows.auto_create`):
    // baris per Distribution Channel dibuatkan.
    salesAutoRows(active) {
      if (active) this.ensureAutoSplitRows(SALES_TAB);
    }
  },
  computed: {
    // Tidak tampil -> tabel General Plant Data melebar penuh (col-12).
    showSales() {
      return this.isTableVisible(SALES_TAB, SALES_FIELD);
    },
    salesAutoRows() {
      return this.showSales && this.isAutoSplitCreateActive(SALES_TAB, SALES_FIELD);
    }
  },
  methods: {
    columnWidth(width) {
      return { width: `${width}px`, minWidth: `${width}px` };
    },
    // Baris hasil split (Distribution Channel kedua dst.) semua kolom terkunci, ikut baris pertama; Distribution Channel
    // sendiri terisi otomatis -> terkunci di semua baris (`split_rows.auto` di config).
    isCellLocked(column, row) {
      return this.isSplitFollower(row) || this.isSplitTargetColumn(SALES_TAB, SALES_FIELD, column);
    },
    // Baris yang nilainya ditampilkan: kolom level item di baris > 0 menampilkan baris pertama.
    valueRow(col, row, index) {
      return col.itemLevel && index > 0 ? (this.dialog.form[SALES_FIELD]?.[0] || row) : row;
    },
    // Hook kerangka bersama, dipanggil tiap item dipilih/berganti. cat_emcr_sales_general sudah di-link ke cat_emcr_plants
    // oleh New_CataloguerForm.hydrateItem (rows_from) -- ensureTableArrays melewatinya.
    onItemBound() {
      this.ensureTableArrays(SALES_TAB);
      this.preloadTabLabels(SALES_TAB);
      // Otomasi baris dari config (row_autofill Profit Center INALUM), termasuk pemicu Material Type di Basic Data.
      // Mode lihat-saja dilewati di kerangka.
      this.watchExternalRowTriggers(SALES_TAB);
      this.applyRowAutomationOnOpen(SALES_TAB);
      // Baris per Distribution Channel (INALUM): dikenali ulang sebagai grup split lalu dilengkapi.
      this.rebuildSplitGroups(SALES_TAB);
      this.ensureAutoSplitRows(SALES_TAB);
    }
  }
};
</script>
